import { getStorefrontCountry } from "@cntrl/native";
import { API_URL } from "../../config/env.js";

/**
 * "Apply online" from the iOS app (ART-346): the web application form, opened in SAFARI — never inside the app, which
 * offers no application and no prices. It carries `from=ios` and the App Store storefront, and the form shows prices
 * only for the US storefront (`hidesPricing`). No storefront (an older app build) ⇒ prices hidden.
 */
export async function openApplyOnline(): Promise<void> {
  const storefront = await getStorefrontCountry();
  const base = API_URL || window.location.origin;
  const query = new URLSearchParams({ from: "ios" });
  if (storefront) query.set("storefront", storefront);
  // An external `_blank` leaves the web view: the native shell hands it to Safari.
  window.open(`${base}/apply?${query.toString()}`, "_blank", "noopener");
}
